import { Injectable } from '@angular/core';
import { AuthenticationService } from './auth.service';
import { MyLog, LogType, LogProcess, LogReport } from '../models/log.models';
import firebase from 'firebase/app';
import 'firebase/firestore';
import { AngularFirestore } from '@angular/fire/firestore';
import { AngularFireFunctions } from '@angular/fire/functions';
import { first, map } from 'rxjs/operators';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LogService {

  // körkörös hivatkozás miatt nincs behúzva a fireStore service
  constructor(private fs: AngularFirestore,
    private auth: AuthenticationService,
    private fireFunctions: AngularFireFunctions) { }

  createError(hostId: string, e: Error, message: string) {
    if (!hostId) {
      hostId = null;
    }
    if (!e) {
      e = null;
    }
    if (!message) {
      message = null;
    }
    const u = this.auth.currentUser();
    const l: MyLog =  {
      hostId,
      // event-t egy az egyben nem szabad beszúrni, mert elhasal a fb!
      // valószínű a stack borítja meg -> undefined
      event: {name: e?.name? e.name : null, message: e?.message ? e.message : null},
      message,
      created: firebase.firestore.FieldValue.serverTimestamp(),
      type: LogType.error,
      // user id undefined, megdögleszti...
      user: {email: u?.email ? u.email : null}
    }
    return this.fs.collection('myLogs').add(l).then(d => {
      console.log('logok',d.id);
      return d.id;
    }).catch(err => {
      console.error('Logbejegyzés létrehozása sikertelen', err);
    })
  }

  createTimeLog(hostId: string, packageId, logId: string,
    processName: string, requestId?: string,
    link?: {linkType: string, id: string},
    reportLog?: LogReport, reportLogId?: string, rackId?: string, boxId?: string): Promise<string> {
    const u = this.auth.currentUser();
    const logDocRef = logId ? this.fs.collection('myLogs').doc(logId) : this.fs.collection('myLogs').doc();
    const process: LogProcess = {
      name: processName,
      created: firebase.firestore.FieldValue.serverTimestamp(),
      requestId: requestId || null,
    };
    let res;
    if (logId) {
      // ha van request id, akkor beírjuk a logfile-ba
      // hogy a cloud functionok meg tudják keresni ez alapján
      // és tölthessék a szerver oldalt
      // const prFieldName = `process.${processName}`;
      let updateDta: any = {process: {[processName]: {}}};
      updateDta.process[processName].name = process.name;
      updateDta.process[processName].created = process.created;
      updateDta.process[processName].requestId = process.requestId;

      // mezőnként, hogy ne írjuk felül a meglévőket
      if (reportLog) {
        updateDta.reportLog = {};
        updateDta.reportLog.created = reportLog.created || null;
        updateDta.reportLog.status = reportLog.status || null;
        updateDta.reportLog.processName = reportLog.processName || null;
        updateDta.reportLog.data = reportLog.data || null;
        updateDta.reportLog.successFinished = reportLog.successFinished || false;
      }

      if (requestId) {
        updateDta.requestId = requestId;
      }

      if (boxId) {
        updateDta.boxId = boxId;
      }

      if (rackId) {
        updateDta.rackId = rackId;
      }
      // a set nem írja felül a nem hivatkozott mezőket, ha merge rtue !!!
      // az update igen
      return logDocRef.set(updateDta, {merge: true})
      .then(() => {
        return logDocRef.ref.id;
      })
      .catch(error => {
        console.error('update timelog error', error);
        return Promise.reject('update timelog error');
      });
    } else {
      return logDocRef.set({
        id: logDocRef.ref.id,
        created: firebase.firestore.FieldValue.serverTimestamp(),
        event: null,
        hostId: hostId || null,
        message: null,
        type: LogType.timeLog,
        user: {email: u?.email ? u.email : null},
        process: {[processName] : process},
        packageId: packageId || null,
        requestId: requestId || null,
        link: link || null,
        reportLog: reportLog ? {
          created:  reportLog.created || null,
          status: reportLog.status || null,
          processName: reportLog.processName || null,
          processType: reportLog.processType || null,
          // ha kliens oldalon csinálunk, akkor updateljük
          // ha nincs töltve, akkor a trigger csinál automatikusan
          // csak amire visszaírja az id-t lehet két logfile is létrejön
          logId: reportLogId || null,
          data: reportLog.data || null,
        } : null,
      })
      .then(() => {
        return logDocRef.ref.id;
      })
      .catch(error => {
        console.error('create timelog error', error);
        return Promise.reject('update timelog error');
      })
    }
  }

  // emiatt viszont aki authentikált, az írhatja a report log collection-t
  // ez csak egy üreset csinál, a többit már a trigger elintézi
  createReportLog(email: string | null, hostId: string,
    packageId?: string, boxId?: string, requestId?: string, processType?: string, linkId?: string) {
    const docRef = this.fs.collection("reportLogs").doc();
    return docRef.set({
      created: firebase.firestore.FieldValue.serverTimestamp(),
      id: docRef.ref.id,
      timeLogId: null,
      process: {},
      packageId: packageId || null,
      boxId: boxId || null,
      requestId: requestId || null,
      user: email ? {email} : linkId ? {linkId: linkId || null} : null,
      hostId,
      type: "reportLog",
      processType: processType || null,
    }).then(() => {
      return docRef.ref.id;
    }).catch(err => {
      console.error("reportLog létrehozás sikertelen", err);
      return Promise.reject("reportLog létrehozás sikertelen");
    })
  }

  createLogServerSide(linkId, logType: string,
    rootProcess: string,
    logMessage: string,
    logLevel: string,
    logId?: string,
    reportLogId?: string,
    runningRequestId?: string,
    createReportLog?: boolean,
    linkType?: string) {
    console.log('call receive logger', new Date(), linkType, runningRequestId);
    const func = this.fireFunctions.httpsCallable('receiveLogger');
    return func({linkId, runningRequestId, createReportLog,
      linkType,
      logInfo: {
        logProcess: logType,
        logMessage,
        logLevel,
        logId,
        reportLogId,
        rootProcess,
    }}).pipe(
      first(),
      map(res => {
        console.log('receive logger respond', new Date(), res);
        if (res.error) {
          throw res.error;
        } else {
          return res.data;
          //return res.data;
        }
      }),
    ).toPromise().then(res => {
      return res;
    }).catch(e => {
      console.error(e);
      return Promise.reject(false);
    });
  }
}
